import FallbackHeader from '@/src/components/elements/Headers/fallback';
import Cookies from 'universal-cookie';
import { useDevice, useGetLocalStorage } from '@/src/hooks/index';
import { useRouter } from 'next/router';
import Home from '@/src/feature/main/user/home';
import Font from '@/src/components/base/Font';
import { productMantri } from '@/src/datas/menu';
import { Card } from '@/src/components';
import style from './index.module.scss';

export default function PageMantri() {
  const device: 'mobile' | 'desktop' | undefined = useDevice();
  const cookie = new Cookies();
  const session = cookie.get('user') !== undefined;
  const data = JSON?.parse(String(useGetLocalStorage('data')));

  const router = useRouter();
  const handleLogin = () => router.push('/login');
  const onRoute = (link: any) => {
    if (link?.includes('rekomendasi_mitra_ultra_mikro')) {
      window.location.assign(`/bridaya/umi/Rekomendasi Mitra Ultra Mikro`);
    } else {
      window.location.assign(link);
    }
  };

  if (device === 'mobile' && !session) {
    return <Home id='page-mantri' />;
  } else if (device === 'mobile' && session) {
    return (
      <div style={{ marginTop: '3rem', marginBottom: '2rem', display: 'grid' }}>
        <Font variant={'subtitle-1-medium'} color={'white'}>
          {`Selamat Datang, `}
        </Font>
        <Font variant={'heading-2-semibold'} color={'white'}>
          {data?.sname || `Pengguna BRIBRAIN`}
        </Font>
        <br />
        {productMantri.map((item, index) => (
          <div key={index} className={style.container}>
            <Card variant={'none'}>
              <div
                className={style.box_menu}
                onClick={() => onRoute(`${item.link}`)}
              >
                <img src={item.icon} height={56} width={56} />
                <Font variant={'subtitle-2-semibold'} color={'gray-2'}>
                  {item.label}
                </Font>
              </div>
            </Card>
          </div>
        ))}
      </div>
    );
  } else if (device === 'desktop') {
    return (
      <>
        <div />
      </>
    );
  }

  return <FallbackHeader />;
}
